export const getMsFromSeconds = (seconds: number) => seconds * 1000;
